import React from 'react';
import {Video, Formatted} from 'components';
import {config} from 'helpers';

export function ValuesGoDeeper() {
  return (
    <Formatted className="medium-spacing">
      <Video.Video src={config.videos.identity.values2} />
      <p>Now that you have identified your core values, it's time to start living them! Choose one of the core values you have identified that you don't always honor. Be honest! Decide to live this value in every aspect of your life for a week. Notice when it is easier to live the value and when it is hard, but push through the barriers and live it.</p>
      <p>If you choose "good health" as your value, everything you do for a week should honor that: eat well, exercise, get enough sleep. If you choose honesty, be honest with everyone about everything, including yourself.</p>
      <p>At the end of the week, think about how it feels to fully live this value. What have you learned?</p>
    </Formatted>
  );
}
